import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-888b338c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-faq" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-block d-md-none page-title" }, " 자주 묻는 질문 ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-none d-md-block page-title" }, " FAQ ", -1))
const _hoisted_4 = { class: "box-content" }
const _hoisted_5 = { class: "tab-label-text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "collapse-symbol" }, " Q. ", -1))
const _hoisted_7 = { class: "collapse-title" }
const _hoisted_8 = { class: "indicator" }
const _hoisted_9 = ["srcset", "media"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["innerHTML"]

import { type ComputedRef, inject } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const images = inject<ComputedRef<Record<string, string>>>('images')!;

const tabs = [
  {
    name: '지원하기',
    data: [
      {
        q: '지원이 완료되었는지 어떻게 알 수 있을까요?',
        a: '지원이 완료되면 등록한 핸드폰 번호로 카카오톡 메시지가 발송되며, 마이페이지에서도 확인할 수 있어요.'
      },
      {
        q: '여러 번 참여할 수 있나요?',
        a: '시즌 5에서는 회차마다 한 번씩, 총 3번의 참여 기회가 있어요. 계정별로 회차당 1회씩 지원 가능하니, 이번 회차에 선정되지 못해도 재도전할 수 있답니다. 단, 시즌 내에 이미 선정되어 캠페인에 참여한 원더플 피플은 다시 참여 기회를 가질 수 없는 점 잊지 마세요! '
      },
      {
        q: '챌린지 유형을 바꾸고 싶어요! 2박스 챌린지에 지원했는데 4박스 챌린지로 바꿀 수 있나요?',
        a: '아쉽지만 챌린지 유형은 신청 후 변경이 불가해요.'
      }
    ],
  },
  {
    name: '수거 신청',
    data: [
      {
        q: '뚜껑을 분실했어요! 페트병 뚜껑을 꼭 닫아야 하나요?',
        a: '뚜껑이 없으면 페트병에서 이물질이 흘러나와 다른 페트병이 오염될 수도 있고, 마르지 않은 물이 흘러나와 박스가 젖을 수도 있어요. 만약, 뚜껑을 분실했다면 더욱 꼼꼼히 세척과 건조에 신경 써주세요. '
      },
      {
        q: '주소 변경 등의 이유로 개인 정보 변경하고 싶어요.',
        a: '마이페이지에서 변경 가능해요. 등록된 주소지로 제로 웨이스트 박스 발송, 수거, 리워드 발송이 진행되므로 정확한 주소를 입력해 주세요.'
      },
      {
        q: '제로 웨이스트 박스 배송비는 본인 부담인가요?',
        a: '원더플 캠페인은 참여자들의 비용 부담 없이 무료로 진행돼요. 원더플 피플은 올바른 분리배출법에 따라 투명 음료 페트병을 모아 주기만 하면 끝!'
      },
      {
        q: '캠페인 기간 내 박스를 다 못 채웠는데 어떡하죠? ',
        a: '수거 신청은 사전에 공지된 기간에만 가능해요. 약속된 기간 내 제로 웨이스트 박스가 수거되지 않으면 리워드가 제공되지 않아요. 미처 미션을 완수하지 못한 원더플 피플이 있다면 환경을 위해 제로 웨이스트 박스와 페트병은 자체적으로 분리배출해 주세요.'
      }
    ],
  },
  {
    name: '리워드/배송',
    data: [
      {
        q: '리워드 배송 일정이 궁금해요',
        a: '올바른 방법으로 투명 음료 페트병을 모아 보내 주신 분들에 한해 순차적으로 배송해 드려요. 제로 웨이스트 박스는 테라사이클에서 하나하나 검수하기 때문에 많은 시간이 소요된답니다. 캠페인 운영 과정에서 리워드 배송이 지연될 수 있는 점 양해 부탁드립니다.'
      },
      {
        q: '리워드를 별도 구매할 수 있나요?',
        a: '리워드는 캠페인에 참여해 주신 원더플 피플에게 감사의 의미로 제공되는 만큼 별도로 판매하지 않아요.'
      }
    ],
  }
];

return (_ctx: any,_cache: any) => {
  const _component_AppCollapse = _resolveComponent("AppCollapse")!
  const _component_AppTab = _resolveComponent("AppTab")!
  const _component_AppTabs = _resolveComponent("AppTabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_AppTabs, null, {
        trigger: _withCtx(({ index, label, active }) => [
          _createElementVNode("div", {
            class: _normalizeClass(["faq-tab-item", { active }]),
            style: _normalizeStyle({ zIndex: tabs.length - index })
          }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(label), 1)
          ], 6)
        ]),
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
            return _createVNode(_component_AppTab, {
              key: tab.name,
              label: tab.name,
              style: {}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab.data, (faq, index) => {
                  return (_openBlock(), _createBlock(_component_AppCollapse, { key: index }, {
                    trigger: _withCtx(({ visible }) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["faq-collapse-trigger", { active: visible }])
                      }, [
                        _hoisted_6,
                        _createElementVNode("div", _hoisted_7, _toDisplayString(faq.q), 1),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("picture", null, [
                            _createElementVNode("source", {
                              srcset: _unref(images)['btn-arrow-down'],
                              media: `(max-width: ${768}px)`
                            }, null, 8, _hoisted_9),
                            _createElementVNode("img", {
                              src: _unref(images)['btn-arrow-down-bg']
                            }, null, 8, _hoisted_10)
                          ])
                        ])
                      ], 2)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "faq-content",
                        innerHTML: faq.a
                      }, null, 8, _hoisted_11)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 2
            }, 1032, ["label"])
          }), 64))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})